import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EditProfile from './EditProfile';
import '../styles/UserMenu.css';

function UserMenu() {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
    const businessId = searchParams.get('businessid');
    if (businessId) {
      navigate(`/?businessid=${businessId}`);
    } else {
      navigate('/');
    }
  };

  const handleEditProfile = () => {
    setIsEditProfileOpen(true);
    setIsMenuOpen(false);
  };

  const handleLogin = () => {
    setIsMenuOpen(false);
    const businessId = searchParams.get('businessid');
    navigate(businessId ? `/login?businessid=${encodeURIComponent(businessId)}` : '/login');
  };

  const userInitial = user?.full_name?.trim()
    ? user.full_name.trim().charAt(0).toUpperCase()
    : user?.phone
      ? user.phone.slice(-1)
      : '?';

  return (
    <>
      <div className="user-menu-container" ref={menuRef}>
        <button
          className={`user-menu-button ${isAuthenticated && user ? 'user-menu-button-avatar' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="User menu"
        >
          {isAuthenticated && user ? (
            <span className="user-menu-avatar" aria-hidden="true">
              {userInitial}
            </span>
          ) : (
            <svg
              className="user-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          )}
        </button>

        {isMenuOpen && (
          <div className="user-menu-dropdown">
            {isAuthenticated && user ? (
              <>
                <div className="user-menu-header">
                  <div className="user-menu-name">{user.full_name || 'المستخدم'}</div>
                  <div className="user-menu-phone">{user.phone}</div>
                </div>
                <div className="user-menu-divider"></div>
                <button
                  className="user-menu-item"
                  onClick={() => { setIsMenuOpen(false); navigate('/bookings'); }}
                >
                  <svg className="menu-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  حجوزاتي
                </button>
                <button
                  className="user-menu-item"
                  onClick={handleEditProfile}
                >
                  <svg
                    className="menu-item-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  تعديل الملف الشخصي
                </button>
                <button
                  className="user-menu-item logout-item"
                  onClick={handleLogout}
                >
                  <svg
                    className="menu-item-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                  تسجيل الخروج
                </button>
              </>
            ) : (
              <button
                className="user-menu-item login-item"
                onClick={handleLogin}
              >
                <svg
                  className="menu-item-icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                تسجيل الدخول
              </button>
            )}
          </div>
        )}
      </div>

      {isEditProfileOpen && isAuthenticated && (
        <EditProfile
          isOpen={isEditProfileOpen}
          onClose={() => setIsEditProfileOpen(false)}
        />
      )}
    </>
  );
}

export default UserMenu;

